import { useEffect, useRef, useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather'
import styled, { css, keyframes } from 'styled-components'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import PeriodBreakdownRow from './PeriodBreakdownRow'

const formatRupiah = (value) => `Rp${newFormatThousandSeparator(value)}`

const flash = keyframes`
  0% {
    background-color: #D1FADF;
    border-color: #039855;
  }
  70% {
    background-color: #F6FEF9;
    border-color: #039855;
  }
  100% {
    background-color: #ffffff;
    border-color: #e5e7eb;
  }
`

const Card = styled.div`
  border-radius: 12px;
  ${(props) =>
		props.$selected
			? css`
          animation: ${flash} 2.5s ease-out;
        `
			: 'animation: none;'}
`

const MobilePeriodCard = ({ row, isSelected, onClose }) => {
	const [open, setOpen] = useState(false)
	const ref = useRef(null)

	useEffect(() => {
		setOpen(isSelected)
		if (isSelected && ref.current) {
			ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
		}
	}, [isSelected])

	const handleToggle = () => {
		if (isSelected) {
			onClose()
		} else {
			setOpen((prev) => !prev)
		}
	}

	return (
		<Card
			ref={ref}
			$selected={isSelected}
			className="border p-3 shadow-sm mt-2 mb-3 bg-white"
		>
			<div
				className="d-flex justify-content-between align-items-start"
				style={{ cursor: 'pointer' }}
				onClick={handleToggle}
			>
				<div>
					<div className="fw-medium" style={{ fontSize: '16px' }}>
						{row.period || row.date}
					</div>
					<div
						className="d-flex flex-column gap-1 mt-1"
						style={{ fontSize: '15px' }}
					>
						<div>
							<span className="text-muted me-2">Pemasukan</span>
							<span className="text-success fw-medium">
								+ {formatRupiah(row.income)}
							</span>
						</div>
						<div>
							<span className="text-muted me-2">Pengeluaran</span>
							<span className="text-danger fw-medium">
								- {formatRupiah(row.expense)}
							</span>
						</div>
					</div>
				</div>
				<div className="text-end">
					<div
						className={`fw-bold ${row.profit >= 0 ? 'text-success' : 'text-danger'}`}
						style={{ fontSize: '16px' }}
					>
						{row.profit >= 0 ? '+ ' : '- '}
						{formatRupiah(Math.abs(row.profit))}
					</div>
					<div
						className="text-muted mt-1 d-inline-flex align-items-center gap-1"
						style={{ fontSize: '14px' }}
					>
						{open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
						<span>Kategori</span>
					</div>
				</div>
			</div>

			{open && (
				<div className="mt-2 pt-2 border-top">
					<PeriodBreakdownRow data={{ breakdown: row.breakdown }} />
				</div>
			)}
		</Card>
	)
}

export default MobilePeriodCard
